import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { PhoneCall, Clock, Globe, Calendar, HelpCircle, ArrowUpRight, MessageSquare } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Voice Agents — Calls Handled Automatically | MindStream.ing
  Meta Desc: MISTR's voice agents take calls, answer questions, schedule appointments, and escalate when needed — automatically, in any language, around the clock.
  Primary KW: AI voice agent for business
*/
export function VoiceAgents() {
  return <FeaturePageLayout seoTitle="AI Voice Agents — Calls Handled Automatically | MindStream.ing" seoDesc="MISTR's voice agents take calls, answer questions, schedule appointments, and escalate when needed — automatically, in any language, around the clock." heroEyebrow="VOICE AGENTS" heroTitle={<>
          Voice Agents That <span className="text-gradient" data-id="element-2867">Never Sleep.</span>
        </>} heroDesc="MR's voice takes calls, answers questions, schedules appointments, and escalates when needed — automatically, in any language, around the clock." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Call Comes In',
      desc: "Inbound calls route directly to MR's voice interface."
    }, {
      title: 'MR Handles',
      desc: 'MR handles intake, answers questions, and books appointments.'
    }, {
      title: 'Smart Escalate',
      desc: 'Only complex or high-value calls are escalated to a human.'
    }]
  }} features={{
    cards: [{
      icon: <MessageSquare size={24} data-id="element-2868" />,
      title: '24/7 Availability',
      desc: 'Never miss a call again. MR is always awake and ready to help.'
    }, {
      icon: <PhoneCall size={24} data-id="element-2869" />,
      title: 'Natural Conversation',
      desc: 'Sounds human, understands context, and handles interruptions gracefully.'
    }, {
      icon: <Globe size={24} data-id="element-2870" />,
      title: 'Any Language',
      desc: 'Speaks and understands multiple languages, switching seamlessly mid-conversation.'
    }, {
      icon: <Calendar size={24} data-id="element-2871" />,
      title: 'Appointment Booking',
      desc: 'Checks your calendar and schedules meetings directly during the call.'
    }, {
      icon: <HelpCircle size={24} data-id="element-2872" />,
      title: 'Question Answering',
      desc: 'Pulls from your ThinkTank to answer FAQs accurately and instantly.'
    }, {
      icon: <ArrowUpRight size={24} data-id="element-2873" />,
      title: 'Smart Escalation',
      desc: 'Knows exactly when to transfer the call to you or your team.'
    }]
  }} data-id="element-2866" />;
}